import {
  SALES_FLOW,
  SALES_TYPE,
  SALES_TYPE_BACKEND_MAPPING,
  DELIVERY_STATUS_DISPLAY,
} from '../../../common/constant/page-constant'
import Pagination from '../../../components/PaginationComponent/Pagination'
import Card from '../../Common/Card/Card'
import { formatDate } from './../../../common/utils/appUtils'
import currencyFormatter from './../../../common/utils/currencyFormatterUtils'

const SaleTabContent = ({
  allSalesFilteredData,
  getSaleDetails,
  handleDeleteHoldSaleOrder,
  pagination,
}) => {
  const getConfirmedOrderStatus = (sale) => {
    let text = ''
    let color = ''
    
    // Only show delivery status for online orders that are confirmed or completed
    if (
      SALES_TYPE.CONFIRMED_LIST.includes(sale.status) &&
      sale.type === SALES_FLOW.ONLINE
    ) {
      // If order is completed, show delivered status
      if (sale.status === SALES_TYPE.COMPLETED) {
        text = 'Delivered'
        color = 'statusGreen'
        return { text, color }
      }
      
      // Get delivery partner status from the sale data
      const deliveryStatus = sale?.delivery_partner?.status
      
      if (deliveryStatus && DELIVERY_STATUS_DISPLAY[deliveryStatus]) {
        const statusInfo = DELIVERY_STATUS_DISPLAY[deliveryStatus]
        text = statusInfo.text
        color = statusInfo.color
      } else if (sale?.delivery_partner?.id) {
        // Fallback: delivery partner assigned but no status
        text = 'Delivery Person Assigned'
        color = 'statusBlue'
      } else {
        // Order confirmed but no delivery partner yet
        text = 'Processing'
        color = 'statusBlue'
      }
    }
    return { text, color }
  }

  return (
    <div className="tabContent">
      <div className="tabPane dFlex">
        {allSalesFilteredData?.map((sale) => (
          <div key={sale.id} className="cardWrap">
            <Card
              headerSup={formatDate(sale.updated_at)}
              handleDeleteHoldSaleOrder={handleDeleteHoldSaleOrder}
              cardCrown={SALES_TYPE_BACKEND_MAPPING[sale.type]}
              primary={sale.type === SALES_FLOW.ONLINE}
              cardRight={`BDT ${currencyFormatter(sale?.total_amount || 0)}`}
              headerMain={sale.invoice_number}
              sales={
                <>
                  <div>
                    {sale.type === SALES_FLOW.OFFLINE
                      ? `Customer: ${sale.customer_name || 'Walk-in Customer'}`
                      : 'Customer: DG ePharma'}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                    Served by: {sale.served_by || sale.created_by_name || sale.created_by?.name || sale.user_name || 'Staff'}
                  </div>
                </>
              }
              orderStatus={getConfirmedOrderStatus(sale)}
              handleClick={() => getSaleDetails(sale.id, sale.status)}
              saleData={sale}
            />
          </div>
        ))}
      </div>

      <div className="tabPane dFlex"></div>

      {allSalesFilteredData.length > 0 && (
        <Pagination
          currentPage={pagination.page}
          totalPages={pagination.totalPages}
          onPageChange={pagination.goToPage}
          onPrevPage={pagination.prevPage}
          onNextPage={pagination.nextPage}
          onFirstPage={pagination.firstPage}
          onLastPage={pagination.lastPage}
          hasNextPage={pagination.hasNextPage}
          hasPrevPage={pagination.hasPrevPage}
          showFirstLast={true}
          maxPageButtons={5}
        />
      )}
    </div>
  )
}

export default SaleTabContent
